import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const style = {
  content: {
    composes: 'report-text-block-width'
  },
  emptyState: {
    border: `4px dashed ${colors.borderGray}`,
    color: colors.borderGray,
    padding: 20,
    textAlign: 'center'
  }
}

export const useStyles = createUseStyles(style)
